import KeyPair from "protico-encryption/dist/KeyPair";
import { useCallback, useMemo } from "react";
import { useAppSelector } from ".";
import { TMessage } from "../types/types";
import { decrypt as decryptFunc } from "../utils/dm.utils";
import { encrypt as encryptFunc } from "../utils/dm.utils";
import { generateMessage as generateMessageFunc } from "../utils/dm.utils";

const useCryptography = () => {
  const { privateKey } = useAppSelector((state) => state.keys);
  const { currentAddress } = useAppSelector((state) => state.auth);
  const userKeypair = useMemo(() => {
    if (!privateKey) return undefined;
    const Uint8PrivateKey = new Uint8Array(Buffer.from(privateKey, "base64"));
    return new KeyPair(currentAddress).fromPrivate(Uint8PrivateKey);
  }, [privateKey, currentAddress]);
  const decrypt = useCallback(
    (message: TMessage) => {
      if (!userKeypair) throw new Error("User has no keypair");
      return decryptFunc(message, userKeypair, currentAddress);
    },
    [userKeypair]
  );
  const encrypt = useCallback(
    (plaintextMessage: string, toPubKeyUint8: Uint8Array) => {
      if (!userKeypair) throw new Error("User has no keypair");
      if (!toPubKeyUint8) throw new Error("The other user has no pubkey");
      return encryptFunc(plaintextMessage, userKeypair, toPubKeyUint8);
    },
    [userKeypair]
  );
  const generateMessage = useCallback(
    (
      plaintextMessage: string,
      toPubKeyUint8: Uint8Array,
      toAddress: string
    ) => {
      if (!toAddress) throw new Error("Wrong target");
      if (!userKeypair) throw new Error("User has no keypair");
      if (!toPubKeyUint8) throw new Error("The other user has no pubkey");
      return generateMessageFunc(
        currentAddress,
        toAddress,
        plaintextMessage,
        userKeypair,
        toPubKeyUint8
      );
    },
    [userKeypair]
  );
  return { userKeypair, decrypt, encrypt, generateMessage };
};
export default useCryptography;
